/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Resetpasswordtitle2Inputs */

const zh_auth_resetpasswordtitle2 = /** @type {(inputs: Auth_Resetpasswordtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置密码`)
};

const en_auth_resetpasswordtitle2 = /** @type {(inputs: Auth_Resetpasswordtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset your password`)
};

const es_auth_resetpasswordtitle2 = /** @type {(inputs: Auth_Resetpasswordtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablece tu contraseña`)
};

/**
* | output |
* | --- |
* | "Reset your password" |
*
* @param {Auth_Resetpasswordtitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_resetpasswordtitle2 = /** @type {((inputs?: Auth_Resetpasswordtitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Resetpasswordtitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_resetpasswordtitle2(inputs)
	if (locale === "en") return en_auth_resetpasswordtitle2(inputs)
	return es_auth_resetpasswordtitle2(inputs)
});
export { auth_resetpasswordtitle2 as "auth_resetPasswordTitle" }